// src/components/flags.ts
export const COUNTRIES = [
  'in', 'cn', 'id', 'bd', 'ng', 'sa', 'ae', 'jp', 'gb', 'kr', 'tr', 'pk', 'ke', 'au', 'eg', 'ph', 'th', 'br', 'us', 'lk',
  'np', 'af', 'iq', 'ir', 'ye', 'sd', 'so', 'et', 'tz', 'ug', 'zw', 'zm', 'gh', 'sn', 'ma', 'dz', 'tn', 'ly', 'jo', 'lb',
  'sy', 'ps', 'kw', 'qa', 'bh', 'om', 'mv', 'mm', 'kh', 'vn', 'sg', 'bn', 'la', 'mn', 'kz', 'uz', 'tj', 'kg', 'tm', 'ru',
  'ua', 'pl', 'de', 'fr', 'it', 'es', 'pt', 'nl', 'be', 'ch', 'se', 'no', 'dk', 'fi', 'gr', 'ie', 'ca', 'mx', 'ar', 'cl',
  'co', 'pe', 've', 'cu', 'ec', 'za', 'ao', 'mz', 'cm', 'ci', 'rw', 'bt', 'tl', 'fj', 'nz', 'pg', 'mu', 'mw', 'ml',
] // 99 countries

export const BUNTING = [
  'in', 'cn', 'id', 'bd', 'ng', 'my', 'ae', 'jp', 'gb', 'kr', 'tr', 'pk', 'ke', 'au', 'eg', 'ph', 'th', 'br', 'us', 'lk',
  'sa', 'de', 'fr', 'it',
]

export const SDG = [
  '#E5243B', '#DDA63A', '#4C9F38', '#C5192D', '#FF3A21', '#26BDE2', '#FCC30B', '#A21942',
  '#FD6925', '#DD1367', '#FD9D24', '#BF8B2E', '#3F7E44', '#0A97D9', '#56C02B', '#00689D', '#19486A',
]

export const flag = (code: string, w: 40 | 80 | 160 = 80) => `https://flagcdn.com/w${w}/${code}.png`
